import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Style from "./Exams.module.css";
import "./Exam.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BallTriangle } from "react-loader-spinner";
import { toast } from "react-toastify";

const Exams = () => {
  const notify = (mess, type) => {
    toast[type](mess);
  };
  const [courseData, setCourseData] = useState(null);
  const [loading, setloading] = useState(false);
  const [subscribedCourseId, setsubscribedCourseId] = useState(null);
  const [studentId, setStudentId] = useState(null);
  console.log(courseData);
  const handeldeleteCousre = async (courseIndex) => {
    try {
      setloading(true);
      const response = await axios.delete(
        `https://itc-541ea27f6158.herokuapp.com/api/v1/subscription`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`
          },
          data: {
            studentId: courseIndex?.studentId,
            courseId: courseIndex?.subscribedCourseId
          }
        }
      );
      setloading(false);
      notify("تم سحب الدوره التعليمية بنجاح", "success");
      if (response.status === 200) {
        const response = await axios.get(`https://itc-541ea27f6158.herokuapp.com/api/v1/subscription/subscribers?subscriptionStatus=APPROVED&page=${currentPage}&size=10`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`
          }
        });
        setloading(false)
        setCourseData(response?.data.data);
      }

      
  
    } catch (error) {
      setloading(false);
      notify(error.response.data.message, "error");
  
      console.error('Error deleting course subscription:', error);
      // Handle error
    }
  };
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  
  const  navigate= useNavigate()
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true)
        const response = await axios.get(`https://itc-541ea27f6158.herokuapp.com/api/v1/subscription/subscribers?subscriptionStatus=APPROVED&page=${currentPage}&size=10&query=${searchQuery}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`
          }
        });
        setloading(false)
        setCourseData(response?.data.data);

      }    catch (error) {
        if (error.response.status === 405) {
          setloading(false)
          navigate('/login') ;
           notify(error.response.data.message, "success");
    
        }
        setloading(false)
    
        notify(error.response.data.message, "success");
    
        console.error('Error fetching profile data:', error);
      }
     
    };
  

    fetchData();
    const storedData = localStorage.getItem('courseData');
    if (storedData) {
      setCourseData(JSON.parse(storedData));
    }

  }, [currentPage,searchQuery]);
  const totalPages = courseData?.totalPages;
  const handlePageChange = (page) => {
      setCurrentPage(page);
  };  
  
  return (
    <>
      <Helmet>
        <title>الطلاب المشتركين</title>
      </Helmet>

      <div className={`${Style.home} bg-gray-100  rounded-xl min-h-screen  `}>
        <form class="max-w-md mx-auto mb-5">
          <label
            for="default-search"
            class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            Search
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                class="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full outline-none p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-green-500"
              placeholder="ابحث عن اسم الطالب او الايميل .."
              value={searchQuery}
              onChange={handleSearchChange}
            />{" "}
          </div>
        </form>
        {loading ? (
          <>
            <div className={`${Style.home2} w-full flex justify-center`}>
              <BallTriangle
                height={100}
                width={100}
                radius={5}
                color="#4fa94d"
                ariaLabel="ball-triangle-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            </div>
          </>
        ) : (
          <>
            <table className="Exam-table">
              <thead className="Exam-table-Head">
                <tr className="flex flex-row  h-15">
                  <th className="max-h-14 flage flex w-16">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="18"
                      viewBox="0 0 20 24"
                      fill="none"
                    >
                      <path
                        d="M0 0L1.50842 0L1.50842 24H0L0 0ZM21 6.75L3.01683 13.4531L3.01683 0.046875L21 6.75ZM4.52525 11.2969L16.7104 6.75L4.52525 2.20313L4.52525 11.2969Z"
                        fill="#009539"
                      />
                    </svg>
                  </th>
                  <th className=" Address-Exam mx-3 p-3 max-h-14 basis-5/6 ">
                    <div className="flex flex-row">
                      <div className="text-right basis-1/4">اسم الطالب</div>
                      <div className="text-center basis-1/4">
                        عنوان الدوره التعليمية
                      </div>
                      <div className="text-center basis-1/4">رقم الهاتف</div>
                      <div className="text-center basis-1/4">الدولة</div>
                    </div>
                  </th>
                  <th className="flex-none Address-Exam-red max-h-14 pt-3 p-5 text-red-600">
                    سحب
                  </th>
                </tr>
              </thead>

              <tbody>
                {courseData?.items?.map((course, cousreIndex) => {
                  return (
                    <>
                      {[cousreIndex + 1].map((index) => (
                        <>
                          <span className={Style.brmedium}></span>
                          <span className={Style.brmedium}></span>

                          <tr className="flex flex-row h-15 ">
                            <th className="max-h-16  flex w-16 flage-Exam">
                              {index}
                            </th>
                            <th className=" Address-Exam-Body mx-3 p-3 max-h-14 basis-5/6 ">
                              <div className="flex flex-row">
                                <div className="text-right basis-1/4">
                                  {course?.studentName}
                                </div>
                                <div className="text-center basis-1/4">
                                  {course?.subscribedCourseTitle}
                                </div>
                                <div className="text-center basis-1/4">
                                  {course?.studentPhone}
                                </div>
                                <div className="text-center basis-1/4">
                                  <p>{course?.studentCountry}</p>
                                </div>
                              </div>
                            </th>
                            <th
                              onClick={() => {
                                document
                                  .getElementById("my_modal_2")
                                  .showModal();
                                setsubscribedCourseId(
                                  course?.subscribedCourseId
                                );
                                setStudentId(course?.studentId);
                              }}
                              className="cursor-pointer flex-none Address-Exam max-h-14 pt-3 p-5"
                            >
                              <i class="text-red-600 fa-solid fa-circle-xmark pt-4 p-2.5 fa-xl"></i>
                            </th>
                          </tr>
                          <dialog id="my_modal_2" className="modal">
                            <div className="modal-box">
                              <h3 className="font-bold text-lg mb-4">
                                هل انت متأكد من سحب من الطالب؟
                              </h3>

                              <div className="modal-action">
                                <form method="dialog" className="mx-auto">
                                  {/* if there is a button in form, it will close the modal */}
                                  <button
                                    onClick={() =>
                                      handeldeleteCousre({
                                        subscribedCourseId,
                                        studentId,
                                      })
                                    }
                                    class="py-2.5 px-5  text-sm font-medium text-white  bg-customGreen rounded-lg border border-gray-200   "
                                  >
                                    تأكيد
                                  </button>
                                  <button class="text-white ms-3 bg-red-600 hover:bg-red-800  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                                    الغاء
                                  </button>
                                </form>
                              </div>
                            </div>
                          </dialog>
                        </>
                      ))}
                    </>
                  );
                })}
              </tbody>
            </table>
            <ul className="flex items-center justify-center my-10 -space-x-px h-10 text-base">
              {/* Previous Button */}
              {currentPage > 1 && (
                <li onClick={() => handlePageChange(currentPage - 1)}>
                  <a
                    href="#"
                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <span className="sr-only">Previous</span>
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 9 4-4-4-4"
                      />
                    </svg>
                  </a>
                </li>
              )}

              {/* Always show page 1 */}
              <li>
                <a
                  onClick={() => handlePageChange(1)}
                  className={`flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                    currentPage === 1
                      ? "font-bold border-green-600 text-green-500"
                      : ""
                  }`}
                >
                  1
                </a>
              </li>

              {/* Dots after first page */}
              {currentPage > 4 && totalPages > 7 && (
                <li>
                  <span className="flex items-center justify-center px-4 h-10 leading-tight text-gray-400 bg-white border border-gray-300">
                    ...
                  </span>
                </li>
              )}

              {/* Middle Pages */}
              {Array.from({ length: 5 }, (_, index) => {
                const page =
                  currentPage <= 3 ? index + 2 : currentPage - 2 + index;
                if (page > 1 && page < totalPages) {
                  return (
                    <li key={page}>
                      <a
                        onClick={() => handlePageChange(page)}
                        className={`flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                          currentPage === page
                            ? "font-bold border-green-600 text-green-500"
                            : ""
                        }`}
                      >
                        {page}
                      </a>
                    </li>
                  );
                }
                return null;
              })}

              {/* Dots before last page */}
              {currentPage < totalPages - 3 && totalPages > 7 && (
                <li>
                  <span className="flex items-center justify-center px-4 h-10 leading-tight text-gray-400 bg-white border border-gray-300">
                    ...
                  </span>
                </li>
              )}

              {/* Always show last page */}
              {totalPages > 1 && (
                <li>
                  <a
                    onClick={() => handlePageChange(totalPages)}
                    className={`flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                      currentPage === totalPages
                        ? "font-bold border-green-600 text-green-500"
                        : ""
                    }`}
                  >
                    {totalPages}
                  </a>
                </li>
              )}

              {/* Next Button */}
              {currentPage < totalPages && (
                <li onClick={() => handlePageChange(currentPage + 1)}>
                  <a
                    href="#"
                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <span className="sr-only">Next</span>
                    <svg
                      className="w-3 h-3 rtl:rotate-180"
                      fill="none"
                      viewBox="0 0 6 10"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 1 1 5l4 4"
                      />
                    </svg>
                  </a>
                </li>
              )}
            </ul>
          </>
        )}
      </div>
    </>
  );
}

export default Exams;
